import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type ServiceOption = {
  id: string;
  name: string;
};

type GetServiceOptionsResponse = {
  serviceOptions: ServiceOption[];
  tmsTenant?: string;
};

export async function getServiceOptions(
  tmsID: number,
  forceRefresh?: boolean
): Promise<Result<GetServiceOptionsResponse, ApiError>> {
  try {
    const queryParams = `tmsID=${tmsID}${forceRefresh ? '&forceRefresh=true' : ''}`;
    const response = await axios.get<GetServiceOptionsResponse>(
      `/service-options/?${queryParams}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getServiceOptions' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get service options from TMS' });
    }

    return err({
      message:
        error.response?.data.message ||
        'Failed to get service options from TMS',
    });
  }
}
